import { v4 as uuidv4 } from "uuid";
export class IntegrationConfigurationModel {
    constructor() {
        this.id = uuidv4();
        this.providerId = uuidv4();
        this.tenantId = uuidv4();
        this.configurations = "";
    }
}
export default class IntegrationConfiguration extends IntegrationConfigurationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
